<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><i>I was in my own room as usual</i>—<i>just myself, without obvious change: nothing had smitten me, or scathed me, or maimed me. And yet, where was the Jane Eyre of yesterday?</i>—<i>where was her life?</i>—<i>where were her prospects?</i></p>
<p class="fm-a"><span>—F<span class="smallcaps">ROM</span> <i>J<span class="smallcaps">ANE</span> E<span class="smallcaps">YRE</span></i>, <span class="smallcaps">BY</span> C<span class="smallcaps">HARLOTTE</span> B<span class="smallcaps">RONTË</span></span></p>
<p class="fm1"><i>The minute I heard my first love story</i></p>
<p class="fm2"><i>I started looking for you, not knowing</i></p>
<p class="fm2"><i>how blind that was</i>.</p>
<p class="fm1"><i>Lovers don’t finally meet somewhere</i>.</p>
<p class="fm2"><i>They’re in each other all along</i>.</p>
<p class="fm3"><span>—J<span class="smallcaps">ALAL AD</span>-D<span class="smallcaps">IN</span> R<span class="smallcaps">UMI</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?20248926